// Site-wide constants for the public shell. Copy lives verbatim in the templates;
// only values that are reused or wired to behaviour are kept here.
export const SITE = {
    // Keep in step with the last entry of SEASONS in src/domain/seasons.js.
    seasonLabel: 'Season 12',
    seasonTerm: 'Fall 2026',
    paypalDonateUrl: 'https://www.paypal.com/donate/?hosted_button_id=FXXKR39S9JS3N',
    copyValues: {
        zelle: 'finance@thedreaminc.org',
        adminmail: 'admin@thedreaminc.org',
    },
};
